import { createFileRoute, redirect } from '@tanstack/react-router'
import { ensureSession } from '@/lib/session'
import { ensureFirstWorkspaceSlug } from '@/lib/workspace'

/**
 * The root path only decides where you belong. Marketing lives in a separate
 * app, so there is no landing page here.
 */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const session = await ensureSession(context.queryClient)

    if (!session) {
      throw redirect({ to: '/login' })
    }

    const workspaceSlug = await ensureFirstWorkspaceSlug(context.queryClient)

    throw redirect(
      workspaceSlug
        ? { to: '/w/$workspaceSlug', params: { workspaceSlug } }
        : { to: '/onboarding' },
    )
  },
})
